var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 9.39803L10.2841 9.33661V11.7322C9.26136 9.39803 8.23864 9.39803 7.27273 11.7322L7.21591 9.33661H3.92045C2.61364 9.64373 1.59091 10.9337 1.59091 12.4079C1.59091 14.1892 2.89773 15.602 4.48864 15.602H11.5909V14.1892H14.6023V15.602H25V17.199C21.5341 17.199 18.0682 17.1376 14.6023 17.1376L14.6591 20.086C13.5795 17.7518 12.6136 17.7518 11.5909 20.086V17.1376C9.20455 17.1376 6.875 17.1376 4.48864 17.1376C2.89773 17.1376 1.59091 18.5504 1.59091 20.2703C1.59091 21.9902 2.89773 23.4644 4.48864 23.4644H25V25C18.125 25 11.1932 24.9386 4.31818 24.9386C1.93182 24.9386 0 22.8501 0 20.2703C0 18.6118 0.795455 17.199 1.98864 16.3391C0.795455 15.5405 0 14.0663 0 12.4079C0 10.8108 0.795455 9.39803 1.93182 8.53808C0.738636 7.73956 0 6.26536 0 4.6683C0 2.08845 1.93182 0 4.31818 0H25V1.53563H4.48864C2.89773 1.53563 1.59091 2.9484 1.59091 4.6683C1.59091 6.20393 2.61364 7.49386 3.97727 7.80098H7.21591V5.83538H10.2273L10.2841 7.80098H25V9.39803Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderSettings);
export default __webpack_public_path__ + "static/media/sliderSettings.eec822e53f523c26fcd9e2e37f2e25ab.svg";
export { ForwardRef as ReactComponent };